export default "__VITE_ASSET__Ci_hIt1Y__";